import { useState } from 'react';
import { Zap } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { useAuth, useMessage } from '../../../../global-components/src';
import { errorMessage } from '../../../../global-components/src/utils/text';
import { api } from '../../../../services/api';

interface Props {
    id_user: number;
    name: string;
    can_pacocar: boolean;
}

const PacocarUser: React.FC<Props> = ({ id_user, name, can_pacocar }) => {
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const { isAuthenticated, token, user: authUser } = useAuth();
    const { setMessage } = useMessage();
    const { t } = useTranslation();

    if (!isAuthenticated || id_user === authUser?.id || !can_pacocar || done) return null;

    const handlePacocar = async () => {
        if (loading) return;

        setLoading(true);
        try {
            await api(token).post(`/users/pacocar/${id_user}`);
            setDone(true);
            setMessage(t('post.actions.pacocarSuccess', { name }), 'success');
        } catch (err) {
            setMessage(errorMessage(err), 'error');
            console.error('Erro ao paçocar usuário:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <li>
            <span
                className={`dropdown-item cursor-pointer user-select-none${loading ? ' disabled' : ''}`}
                onClick={handlePacocar}
                aria-disabled={loading}
            >
                <div className="div-icon-fix">
                    <div className="div-icon-block">
                        <Zap className="icon-config-post" />
                        {t('post.actions.pacocar', { name })}
                    </div>
                </div>
            </span>
        </li>
    );
};

export default PacocarUser;
